import styles from './ListTable.module.scss';

type Props = {
    children: React.ReactNode;
};

const LTPlaceholder = ({ children }: Props) => {
    return <div className={styles.placeholder}>{children}</div>;
};

export { LTPlaceholder };
